import { getList }          from "infraMonitor/actions"
import setFiscalyear        from "infraMonitor/fiscalyear/actions"
import { number }           from "localization"
import React, { Component } from "react"
import onClickOutside       from "react-onclickoutside"

import { connect }    from "react-redux"
import { withRouter } from "react-router-dom"
import { Transition } from "react-transition-group"
import {
    Dropdown,
    DropdownButton,
    DropdownIcon,
    DropdownMenu,
    Title,
    transitionStyles,
}                     from "./style"

class FiscalYearDropdown extends Component {
    state = {
        isOpen: false,
        year: "",
    }

    onYearSelect = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    handleChange = year => {
        const { dispatchFiscalYear, fiscalYear } = this.props
        let { search } = this.props.history.location

        this.setState(
            {
                isOpen: false,
            },
            () => {
                if (fiscalYear !== year) {
                    dispatchFiscalYear(year)
                    if (!search || search.includes("year"))
                        this.props.history.push({ search: `?fiscal-year=${year}` })
                    else
                        this.props.history.push({
                            search: search.concat(`&year=${year}`),
                        })
                }
            },
        )
    }

    handleClickOutside = () => {
        if (this.state.isOpen) {
            this.setState({
                isOpen: false,
            })
        }
    }

    render() {
        const { fiscalYears, fiscalYear, selectedLanguage } = this.props
        const { isOpen } = this.state;
        const activeClass = isOpen ? 'active-dropdown' : '';

        return (
            <Dropdown>
                <DropdownButton onClick={this.onYearSelect} className={`${activeClass}`}>
                    <Title className="title">{number(fiscalYear)}</Title>
                    <DropdownIcon isOpen={this.state.isOpen}/>
                </DropdownButton>

                <Transition in={this.state.isOpen} timeout={100} mountOnEnter={true}>
                    {state => (
                        <DropdownMenu
                            style={{
                                ...transitionStyles[state],
                            }}
                        >
                            <ul className="dropdown-list">
                                {fiscalYears.map((year, key) => (
                                    <li
                                        className="dropdown-list-item"
                                        key={key}
                                        onClick={() => this.handleChange(year.name)}
                                    >
                                        {selectedLanguage === "np" ? year.title_ne : year.title_en}
                                    </li>
                                ))}
                            </ul>
                        </DropdownMenu>
                    )}
                </Transition>
            </Dropdown>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedLanguage: state.localizationReducers.selectedLanguage,
        fiscalYears: state.staticData.fiscalYears,
        fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
    }
}

const mapDispatchToProps = dispatch => ({
    dispatchFiscalYear: year => {
        dispatch(getList())
        dispatch(setFiscalyear(year))
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(onClickOutside(FiscalYearDropdown)))



// WEBPACK FOOTER //
// ./src/components/layouts/dropdowns/fiscalYearDropdown.js